import { confirm } from 'devextreme/ui/dialog';
import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import { deleteApi } from '../../apiUtils';
import { TaskTemplatesDatagrid } from '../../components/datagrid/TaskTemplatesDatagrid';
import { Loader } from '../../components/loader/Loader';
import { useAssetClass } from '../../contexts/assetClass';
import { useAuth } from '../../contexts/auth';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useTranslation } from '../../contexts/translation';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function TaskTemplates() {
  const { user } = useAuth();
  const history = useHistory();
  const { assetClass } = useAssetClass();
  const { setValue } = useBreadcrumbs();
  const { translate } = useTranslation();
  const transFormName = 'TaskTemplates.List';

  const {
    data: taskTemplates,
    isValidating: taskTemplatesValidating,
    error: taskTemplatesError,
    mutate: refetchTemplates,
  } = useSWR<any>(user ? `${API_URL.TASK_TEMPLATE_LIST}` : '', fetcher, swrConfig);

  const handleDelete = useCallback(async (e: any) => {
    if (
      !(await confirm(
        translate!(`Are you sure you want to delete template?`, transFormName),
        translate!('Confirm', ''),
      ))
    )
      return;

    await deleteApi({
      url: `${API_URL.TASK_TEMPLATE_DELETE}`,
      id: e.row.data.id,
      callAfterSuccess: () => {
        refetchTemplates();
      },
    });
  }, []);

  const handleEditButton = (e): void => {
    history.push(`/task-templates/edit/${e.row.data.id}`);
  };

  useEffect(() => {
    setValue({
      pageName: 'Task templates',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  if (!user || !taskTemplates) return <Loader />;

  return (
    <PageContentWrapper
      error={taskTemplatesError}
      loading={!taskTemplates || taskTemplatesValidating}
    >
      <TaskTemplatesDatagrid
        data={taskTemplates.filter(
          (x) => x.userId === user.personalNumber && x.assetClassId === assetClass,
        )}
        handleDelete={(e: any) => handleDelete(e)}
        handleEdit={(e: any) => handleEditButton(e)}
      />
    </PageContentWrapper>
  );
}

export default TaskTemplates;
